// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: #1f2937;
  font-family: Arial, Helvetica, sans-serif;
}

.spreadsheet {
  border: 1px solid #b7c3d0;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.worksheet-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 38px;
  padding: 5px 8px;
  border-bottom: 1px solid #b7c3d0;
  background: #f7f9fb;
}

.worksheet-toolbar__title {
  margin-right: 4px;
  color: #52606d;
  font-size: 12px;
  font-weight: 600;
}

.dimension-field {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #52606d;
  font-size: 12px;
}

.dimension-field input {
  width: 62px;
  height: 26px;
  box-sizing: border-box;
  padding: 3px 5px;
  border: 1px solid #aeb9c5;
  border-radius: 3px;
  background: #fff;
  color: #1f2937;
  font: inherit;
}

.dimension-field input:focus {
  border-color: #217346;
  outline: none;
  box-shadow: 0 0 0 1px #217346;
}

.formula-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 8px;
  border-bottom: 1px solid #b7c3d0;
  background: #f7f9fb;
}

.name-box {
  flex: 0 0 62px;
  padding: 6px 8px;
  border: 1px solid #aeb9c5;
  border-radius: 3px;
  background: #fff;
  color: #374151;
  font-size: 13px;
  text-align: center;
}

.formula-symbol {
  color: #52606d;
  font-family: Georgia, serif;
  font-size: 17px;
  font-style: italic;
  font-weight: 700;
}

.formula-input {
  min-width: 0;
  flex: 1;
  height: 28px;
  padding: 3px 8px;
  border: 1px solid #aeb9c5;
  border-radius: 3px;
  outline: none;
  background: #fff;
  font: inherit;
  font-size: 13px;
}

.formula-input:focus {
  border-color: #217346;
  box-shadow: 0 0 0 1px #217346;
}

.formula-input--error {
  border-color: #c62828;
}

.error-message {
  max-width: 32%;
  overflow: hidden;
  color: #b42318;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-scroller {
  max-width: 100%;
  max-height: 70vh;
  overflow: auto;
}

.worksheet-grid {
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  min-width: 720px;
  width: 100%;
}

.corner-header,
.column-header,
.row-header {
  position: sticky;
  z-index: 2;
  background: #e2e8f0;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
}

.corner-header {
  top: 0;
  left: 0;
  z-index: 4;
  width: 42px;
  min-width: 42px;
  border-right: 1px solid #b7c3d0;
  border-bottom: 1px solid #b7c3d0;
}

.column-header {
  top: 0;
  height: 30px;
  border-right: 1px solid #c7d0da;
  border-bottom: 1px solid #b7c3d0;
}

.row-header {
  left: 0;
  width: 42px;
  min-width: 42px;
  border-right: 1px solid #b7c3d0;
  border-bottom: 1px solid #c7d0da;
}

.cell {
  position: relative;
  height: 28px;
  padding: 0;
  border-right: 1px solid #d5dce3;
  border-bottom: 1px solid #d5dce3;
  background: #fff;
}

.cell:hover {
  background: #f1f8f4;
}

.cell--selected {
  z-index: 1;
  box-shadow: inset 0 0 0 2px #217346;
}

.cell--error {
  background: #fff1f0;
  box-shadow: inset 0 0 0 1px #d92d20;
}

.cell--selected.cell--error {
  box-shadow: inset 0 0 0 2px #d92d20;
}

.cell-input {
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px 6px;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 13px;
  text-align: left;
}

.cell-input:focus {
  outline: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/spreadsheet/spreadsheet.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,qBAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,6BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;;;EAGE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;EACA,gCAAA;AACF;;AAEA;EACE,MAAA;EACA,YAAA;EACA,+BAAA;EACA,gCAAA;AACF;;AAEA;EACE,OAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;EACA,gCAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,mCAAA;AACF;;AAEA;EACE,mBAAA;EACA,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: #1f2937;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.spreadsheet {\n  border: 1px solid #b7c3d0;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgb(15 23 42 / 8%);\n  overflow: hidden;\n}\n\n.worksheet-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 38px;\n  padding: 5px 8px;\n  border-bottom: 1px solid #b7c3d0;\n  background: #f7f9fb;\n}\n\n.worksheet-toolbar__title {\n  margin-right: 4px;\n  color: #52606d;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.dimension-field {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #52606d;\n  font-size: 12px;\n}\n\n.dimension-field input {\n  width: 62px;\n  height: 26px;\n  box-sizing: border-box;\n  padding: 3px 5px;\n  border: 1px solid #aeb9c5;\n  border-radius: 3px;\n  background: #fff;\n  color: #1f2937;\n  font: inherit;\n}\n\n.dimension-field input:focus {\n  border-color: #217346;\n  outline: none;\n  box-shadow: 0 0 0 1px #217346;\n}\n\n.formula-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 8px;\n  border-bottom: 1px solid #b7c3d0;\n  background: #f7f9fb;\n}\n\n.name-box {\n  flex: 0 0 62px;\n  padding: 6px 8px;\n  border: 1px solid #aeb9c5;\n  border-radius: 3px;\n  background: #fff;\n  color: #374151;\n  font-size: 13px;\n  text-align: center;\n}\n\n.formula-symbol {\n  color: #52606d;\n  font-family: Georgia, serif;\n  font-size: 17px;\n  font-style: italic;\n  font-weight: 700;\n}\n\n.formula-input {\n  min-width: 0;\n  flex: 1;\n  height: 28px;\n  padding: 3px 8px;\n  border: 1px solid #aeb9c5;\n  border-radius: 3px;\n  outline: none;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n}\n\n.formula-input:focus {\n  border-color: #217346;\n  box-shadow: 0 0 0 1px #217346;\n}\n\n.formula-input--error {\n  border-color: #c62828;\n}\n\n.error-message {\n  max-width: 32%;\n  overflow: hidden;\n  color: #b42318;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.grid-scroller {\n  max-width: 100%;\n  max-height: 70vh;\n  overflow: auto;\n}\n\n.worksheet-grid {\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n  min-width: 720px;\n  width: 100%;\n}\n\n.corner-header,\n.column-header,\n.row-header {\n  position: sticky;\n  z-index: 2;\n  background: #e2e8f0;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  user-select: none;\n}\n\n.corner-header {\n  top: 0;\n  left: 0;\n  z-index: 4;\n  width: 42px;\n  min-width: 42px;\n  border-right: 1px solid #b7c3d0;\n  border-bottom: 1px solid #b7c3d0;\n}\n\n.column-header {\n  top: 0;\n  height: 30px;\n  border-right: 1px solid #c7d0da;\n  border-bottom: 1px solid #b7c3d0;\n}\n\n.row-header {\n  left: 0;\n  width: 42px;\n  min-width: 42px;\n  border-right: 1px solid #b7c3d0;\n  border-bottom: 1px solid #c7d0da;\n}\n\n.cell {\n  position: relative;\n  height: 28px;\n  padding: 0;\n  border-right: 1px solid #d5dce3;\n  border-bottom: 1px solid #d5dce3;\n  background: #fff;\n}\n\n.cell:hover {\n  background: #f1f8f4;\n}\n\n.cell--selected {\n  z-index: 1;\n  box-shadow: inset 0 0 0 2px #217346;\n}\n\n.cell--error {\n  background: #fff1f0;\n  box-shadow: inset 0 0 0 1px #d92d20;\n}\n\n.cell--selected.cell--error {\n  box-shadow: inset 0 0 0 2px #d92d20;\n}\n\n.cell-input {\n  display: block;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 3px 6px;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: 13px;\n  text-align: left;\n}\n\n.cell-input:focus {\n  outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
